module.exports = __webpack_public_path__ + "media/images/area-badges/land-stewardship-1793338001daa358c73378e4fd8369da.svg";